import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { t } from 'i18n-js';
import versionJson from 'version-info.json';

import { getVersion, IVersion } from '@lootboy/lib/api/version';
import { authSelector } from '@lootboy/lib/selectors';
import { NOOP } from '@lootboy/lib/utils';

import { CircleLoader } from '~/components/atoms/CircleLoader';
import { MenuViewHeader } from '~/components/MenuViewHeader';

import { TAuth } from '~/interfaces/TAuth';

import styles from './VersionPopup.module.scss';

export function VersionPopup(): JSX.Element {
  const { apiUrl }: TAuth = useSelector(authSelector);
  const history = useHistory();
  const [version, setVersion] = useState<IVersion | null>(null);

  useEffect(() => {
    getVersion(apiUrl).then(setVersion).catch(NOOP);
  }, [apiUrl]);

  return (
    <>
      <MenuViewHeader
        title={t('VersionView_header')}
        onClose={history.goBack}
      />
      <section>
        <h2>{t('VersionView_web_header')}</h2>
        <ul>
          <li>
            {t('VersionView_display_version', {
              displayVersion: versionJson.version,
            })}
          </li>
          <li>
            {t('VersionView_builddate', {
              buildDate: versionJson.buildDate,
            })}
          </li>
        </ul>
      </section>
      {version ? (
        <section>
          <h2>{t('VersionView_api_header')}</h2>
          <ul>
            <li>{t('VersionView_api_url', { url: apiUrl })}</li>
            <li>
              {t('VersionView_display_version', {
                displayVersion: version.displayVersion,
              })}
            </li>
            <li>
              {t('VersionView_git_commit', {
                gitCommit: version.gitRevision,
              })}
            </li>
            <li>
              {t('VersionView_builddate', {
                buildDate: version.buildDate,
              })}
            </li>
          </ul>
        </section>
      ) : (
        <CircleLoader
          size={50}
          className={styles.loader}
        />
      )}
    </>
  );
}
